// --- ENGLISH TRANSLATION --- //

// Translation Files From '@/assets/locales/en/'
const req = require.context('@/assets/locales/en/', true, /^(.*\.(json$))[^.]*$/im)

const translations = {}

req.keys().forEach((file) => {
  const name = file.replace('./', '').replace('.json', '')
  translations[name] = req(file)
})

// Translation Files From Other Paths
const others = {
}

const files = Object.assign(translations, others)

export default files
